module.exports = __webpack_public_path__ + "static/media/468x60_0007_ru.3ddac6be.png";